import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Guides from './pages/Guides';
import ChoisirSiteParisFiable from './pages/guides/ChoisirSiteParisFiable';
import UtiliserBonusBienvenue from './pages/guides/UtiliserBonusBienvenue';
import ParierFootball from './pages/guides/ParierFootball';
import ParierTennis from './pages/guides/ParierTennis';
import GererBankroll from './pages/guides/GererBankroll';
import LireCotes from './pages/guides/LireCotes';
import RetirerGains from './pages/guides/RetirerGains';
import TypesParisDisponibles from './pages/guides/TypesParisDisponibles';
import SecuriteProtectionJoueurs from './pages/guides/SecuriteProtectionJoueurs';
import News from './pages/News';
import NouvellesReglementationsANJ2025 from './pages/news/NouvellesReglementationsANJ2025';
import ComparatifBonusBienvenueDecembre2025 from './pages/news/ComparatifBonusBienvenueDecembre2025';
import TendancesParisSportifsNovembre2025 from './pages/news/TendancesParisSportifsNovembre2025';
import NouveauxSitesParisFrance2025 from './pages/news/NouveauxSitesParisFrance2025';
import StrategiesParisDirect2025 from './pages/news/StrategiesParisDirect2025';
import ImpactCoupeMondeParisFrance from './pages/news/ImpactCoupeMondeParisFrance';
import SecuriteDonneesParisEnLigne from './pages/news/SecuriteDonneesParisEnLigne';
import ApplicationsMobileParisComparatif2025 from './pages/news/ApplicationsMobileParisComparatif2025';
import JeuResponsableNouveauxOutils2025 from './pages/news/JeuResponsableNouveauxOutils2025';
import Reviews from './pages/Reviews';
import Betclic from './pages/reviews/Betclic';
import Olybet from './pages/reviews/Olybet';
import Genybet from './pages/reviews/Genybet';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import ResponsibleGaming from './pages/ResponsibleGaming';
import { lazy, Suspense } from 'react';
import ScrollToTop from './components/ScrollToTop';

// Defer non-critical components to improve LCP
const SEO = lazy(() => import('./components/SEO'));
const AgeVerification = lazy(() => import('./components/AgeVerification'));
const CookieConsent = lazy(() => import('./components/CookieConsent'));

function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={null}>
        <SEO />
      </Suspense>
      <Suspense fallback={null}>
        <AgeVerification />
      </Suspense>
      <Suspense fallback={null}>
        <CookieConsent />
      </Suspense>
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/guides" element={<Guides />} />
      <Route path="/guides/choisir-site-paris-fiable" element={<ChoisirSiteParisFiable />} />
      <Route path="/guides/utiliser-bonus-bienvenue" element={<UtiliserBonusBienvenue />} />
      <Route path="/guides/parier-football" element={<ParierFootball />} />
      <Route path="/guides/parier-tennis" element={<ParierTennis />} />
      <Route path="/guides/gerer-bankroll" element={<GererBankroll />} />
      <Route path="/guides/lire-cotes" element={<LireCotes />} />
      <Route path="/guides/retirer-gains" element={<RetirerGains />} />
      <Route path="/guides/types-paris-disponibles" element={<TypesParisDisponibles />} />
      <Route path="/guides/securite-protection-joueurs" element={<SecuriteProtectionJoueurs />} />
      <Route path="/news" element={<News />} />
      <Route path="/news/nouvelles-reglementations-anj-2025" element={<NouvellesReglementationsANJ2025 />} />
      <Route path="/news/comparatif-bonus-bienvenue-decembre-2025" element={<ComparatifBonusBienvenueDecembre2025 />} />
      <Route path="/news/tendances-paris-sportifs-novembre-2025" element={<TendancesParisSportifsNovembre2025 />} />
      <Route path="/news/nouveaux-sites-paris-france-2025" element={<NouveauxSitesParisFrance2025 />} />
      <Route path="/news/strategies-paris-direct-2025" element={<StrategiesParisDirect2025 />} />
      <Route path="/news/impact-coupe-monde-paris-france" element={<ImpactCoupeMondeParisFrance />} />
      <Route path="/news/securite-donnees-paris-en-ligne" element={<SecuriteDonneesParisEnLigne />} />
      <Route path="/news/applications-mobile-paris-comparatif-2025" element={<ApplicationsMobileParisComparatif2025 />} />
      <Route path="/news/jeu-responsable-nouveaux-outils-2025" element={<JeuResponsableNouveauxOutils2025 />} />
      <Route path="/reviews" element={<Reviews />} />
      <Route path="/reviews/betclic" element={<Betclic />} />
      <Route path="/reviews/olybet" element={<Olybet />} />
      <Route path="/reviews/genybet" element={<Genybet />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
      </Routes>
    </>
  );
}

export default App;
